import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './GameCrumb.module.scss';

const GameCrumb: React.FC = () => {
	const { deleteGameFromRestaurant, games } = useContext<IGameAssignmentContext>(GameAssignmentContext);

	return (
		<div className={style.container} data-test="GameCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="gamesLabel"
					size="s"
					weight="bold"
				/>
				{games.map((restaurant, i) => {
					const isAnyGameSelected = !!restaurant.games.length;

					return (
						<div key={restaurant.restaurantId} data-test={`item-${i}`}>
							{isAnyGameSelected && (
								<Text
									className={style.sectionName}
									translationKey={restaurant.restaurantAddress}
									size="xs"
									withTooltip={true}
								/>
							)}
							<div className={style.selectedItemWrapper}>
								{restaurant.games.map((game) => {
									return (
										<SelectedItemForBreadcrumbs
											key={game.gameId}
											label={game.gameName || ''}
											onDelete={() =>
												deleteGameFromRestaurant(restaurant.restaurantId, game.gameId)
											}
										/>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default GameCrumb;
